<template>
  <div class="container">
    <!-- <el-form ref="searchForm" :model="searchData" inline>
      <el-form-item label="UID">
        <el-input v-model.number="searchData.user_id" size="mini" />
      </el-form-item>
      <el-form-item>
        <el-button size="mini" @click="handleSearch">
            查找
        </el-button>
      </el-form-item>
    </el-form> -->

    <div class="head">
      <el-button type="primary" @click="handleAdd" size="small">添加通知</el-button>
      <el-button type="primary" @click="handleViewDoc" size="small">帮助文档</el-button>
    </div>

    <el-table
      :data="data"
    >
      <el-table-column
        prop="id"
        label="ID"
      />

      <el-table-column
        prop="name"
        label="名称"
      />

      <el-table-column
        prop="event"
        label="事件"
      />

      <el-table-column
        prop="event_status"
        label="事件状态"
      />


      <el-table-column
        prop="endpoint_type"
        label="通知类型"
      />
    
      <el-table-column
        prop="tpl_id"
        label="模版ID"
      />

      <el-table-column
        prop="module"
        label="数据模块"
      >
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.module" :key="index">
            {{ item }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
      >
        <template slot-scope="scope">
          <el-button size='mini' type="danger" @click="handleDetele(scope.row)"> 下线 </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pager
      ref="pager"
      api="notice_list"
      :filter="filter"
      :sort="sort"
      :defaultPageSize="100"
      model="messenger"
      @data-changed="onDataChanged"
    />

    <el-dialog 
      title="新增通知"
      :visible.sync="showEditForm"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleEditFormDialogClose"
    >

      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right">
        <el-form-item prop="event" label="事件:" label-width="150px">
          <el-input v-model="editForm.event" style="width:50%" />
        </el-form-item>
        
        <el-form-item prop="event_status" label="事件状态:" label-width="150px">
          <el-input v-model="editForm.event_status" style="width:50%" type="number" />
        </el-form-item>
        
        <el-form-item prop="name" label="名称:" label-width="150px">
          <el-input v-model="editForm.name" style="width:50%" />
        </el-form-item>

        <el-form-item prop="endpoint_type" label="通知类型:" label-width="150px">
          <el-select v-model="editForm.endpoint_type" placeholder="请选择" style="width:50%">
            <el-option
              v-for="(item, index) in typeList"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item prop="tpl_id" label="模版ID:" label-width="150px">
          <el-input v-model="editForm.tpl_id" style="width:50%" />
        </el-form-item>
        
        <el-form-item prop="module" label="数据模块:" label-width="150px">
          <el-select v-model="editForm.module" placeholder="请选择" style="width:50%">
            <el-option
              v-for="(item, index) in moduleList"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>

      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditForm = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveAdd">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog 
      title="帮助文档"
      :visible.sync="showDoc"
    >
      <iframe class="iframe" src="/template/a.html" />
    </el-dialog>
  </div>
</template>
<script>
  import Pager from "../ui/Pager"
  import request from "@/api/request";
  const initForm = {
    event: null,
    endpoint_type: null,
    tpl_id: null,
    module: null,
    name: null
  }
  export default {
    name: 'OrderList',
    components: { Pager },
    data () {
      return {
        searchData: {},
        data: [],
        filter: {},
        sort: [],
        moduleList: [],
        typeList: [],
        editForm: { ...initForm },
        editRules: {
          event: [
            {
              required: true,
              message: '不能为空',
            }
          ],
          endpoint_type: [
            {
              required: true,
              message: '不能为空',
            }
          ],
          tpl_id: [
            {
              required: true,
              message: '不能为空',
            }
          ],
          module: [
            {
              required: true,
              message: '不能为空',
            }
          ],
          name: [
            {
              required: true,
              message: "名称不能为空"
            }
          ]
        },
        showEditForm: false,
        showDoc: false
      }
    },
    computed: {
    
    },
    methods: {
      onDataChanged: function (data) {
        this.data = data
      },
      handleSearch() {
        let filter = {}
        this.filter = filter
      },
      handleAdd() {
        this.editForm = { ...initForm }
        this.getModuleList()
        this.getTypeList()
        this.showEditForm = true
      },
      handleSaveAdd() {
        this.$refs.editForm.validate(async valid => {
          if (valid) {
            this.$refs.editForm.clearValidate()
            const param = {
              event: this.editForm.event,
              endpoint_type: this.editForm.endpoint_type,
              tpl_id: this.editForm.tpl_id,
              module: [this.editForm.module],
              name: this.editForm.name
            }
            if (this.editForm.event_status) {
              param.event_status = Number(this.editForm.event_status)
            }
            
            await request.messenger
              .post("notice_create", param)
              .then(() => {
                this.$message.success("添加成功")
              })
            this.showEditForm = false;
            this.$refs.pager.loadData()
          }
        })
      },
      handleDetele(row) {
        this.$confirm(`确定要下线 ID 为 ${row.id} 的事件`)
          .then(() => {
            this.deteleNotice(row.id)
          })
      },
      handleEditFormDialogClose() {
        this.$refs.editForm.resetFields()
        this.$refs.editForm.clearValidate()
      },
      handleViewDoc() {
        this.showDoc = true
      },
      getModuleList() {
        request.messenger
          .post("notice_module_get")
          .then(response => {
            this.moduleList = response.data
          })
          .catch(data => {
            this.$message.error(data.err)
          })
      },
      getTypeList() {
        request.tools
          .post("defined_get", { prefix: "EPT_"})
          .then(response => {
            this.typeList = response.data
          })
          .catch(data => {
            this.$message.error(data.err)
          })
      },
      deteleNotice(id) {
        request.messenger.post("notice_delete", {
                id: id
            }).then(() => {
                this.$message.success('下线成功')
            }).catch(data => {
                this.$message.error(data.err)
            })
      }
    }
  }
</script>
<style scoped>
  .iframe {
    width: 100%;
    height: auto;
    min-height: 1000px;
  }
</style>